import { motion } from "framer-motion";
import { Shield, Users, ThumbsUp } from "lucide-react";
import { Badge } from "@/components/ui/badge";

interface TrustBadgesProps {
  isPro: boolean;
}

export const TrustBadges = ({ isPro }: TrustBadgesProps) => {
  if (!isPro) return null;

  return (
    <section className="py-16 px-4 bg-gray-50">
      <div className="max-w-4xl mx-auto">
        <h2 className="text-3xl font-mono font-bold text-primary text-center mb-12">
          On est sérieux (mais pas trop)
        </h2>
        
        <div className="grid md:grid-cols-3 gap-8">
          <motion.div
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.5 }}
            className="flex flex-col items-center text-center space-y-4"
          >
            <div className="w-16 h-16 bg-secondary/10 rounded-full flex items-center justify-center mb-4">
              <Shield className="w-8 h-8 text-secondary" />
            </div>
            <Badge variant="secondary" className="text-lg py-2 px-4">
              Garantie Anti-Nulité
            </Badge>
            <p className="text-gray-600">
              6 mois offerts pour les 300 premiers pros 🚨
              Parce que l'Aisne mérite des outils qui déchirent. Et vous aussi.
            </p>
          </motion.div>

          <motion.div
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.5, delay: 0.2 }}
            className="flex flex-col items-center text-center space-y-4"
          >
            <div className="w-16 h-16 bg-secondary/10 rounded-full flex items-center justify-center mb-4">
              <Users className="w-8 h-8 text-secondary" />
            </div>
            <Badge variant="secondary" className="text-lg py-2 px-4">
              Déjà +50 pros intéressés
            </Badge>
            <p className="text-gray-600">
              On a sondé les restaurateurs, hôteliers et bars locaux : ils sont prêts à tenter l'aventure NLocale dès le démarrage.
            </p>
          </motion.div>

          <motion.div
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.5, delay: 0.3 }}
            className="flex flex-col items-center text-center space-y-4"
          >
            <div className="w-16 h-16 bg-secondary/10 rounded-full flex items-center justify-center mb-4">
              <ThumbsUp className="w-8 h-8 text-secondary" />
            </div>
            <Badge variant="secondary" className="text-lg py-2 px-4">
              99% de satisfaction
            </Badge>
            <p className="text-gray-600">
              Petit échantillon, grand enthousiasme : la quasi-totalité réclame déjà l'accès en avant-première
            </p>
          </motion.div>
        </div>
      </div>
    </section>
  );
};